import axios from "axios";
import config from "../config";
import queryString from "query-string";
import CryptoJS from "crypto-js";

export const makeAPICall = (apiData) => {
  let {
    url,
    dispatch,
    defaultAction,
    successAction,
    failedAction,
    params = {},
    type,
    responseType,
    callback,
    errCallback,
    callbackData = {},
    signal,
    headers,
    extraData,
    tab,
  } = apiData;

  if (!url || url.indexOf(window.REACT_APP_METHOD) === -1) {
    dispatch({
      type: null,
      payload: null,
    });
    return Promise.reject();
  }

  let encData = CryptoJS.HmacSHA256(
    JSON.stringify(params),
    "partner_onboard",
  ).toString(CryptoJS.enc.Hex);
  let requestHeaders = {
    ...headers,
    "Content-Type": "application/json",
    "Content-Security-Policy": "default-src 'none'",
    "X-Frame-Options": "SAMEORIGIN",
    "X-XSS-Protection": "1; mode=block",
    "X-Content-Type-Options": "nosniff",
    "X-Encrypted-Body": encData,
  };

  // Add service token to headers if TOKEN = "Y"
  if (window.TOKEN === "Y") {
    const serviceToken = sessionStorage.getItem("pctoken");
    if (serviceToken) {
      requestHeaders.servicetoken = serviceToken;
    }
  }

  let apiObj = {
    method: type ? type : "GET",
    headers: requestHeaders,
    ...(signal && { signal }),
    withCredentials: true,
    mode: "no-cors",
  };

  if (defaultAction) {
    dispatch({
      type: defaultAction,
      payload: null,
      tab: tab,
      extraData: extraData,
    });
  }

  if (type === "GET") {
  } else {
    apiObj.data = JSON.stringify(params);
    apiObj.method = "POST";
  }
  if (responseType) {
    apiObj.responseType = responseType;
  }

  apiObj.url = url;
  // console.log("apiObj", apiObj, params);
  return axios(apiObj)
    .then((response) => {
      try {
        // console.log("---->", response?.headers?.["x-encrypted-response"]);
        // console.log(response);
        const xEncryptedResponse = response?.headers?.["x-encrypted-response"];
        response = response?.data;
        // eslint-disable-next-line
        // console.log(
        //   CryptoJS.HmacSHA256(
        //     JSON.stringify(response),
        //     "partner_central_analytics"
        //   ).toString(CryptoJS.enc.Hex)
        // );
        if (
          (response &&
            response?.message == "SUCCESS" &&
            xEncryptedResponse ===
              CryptoJS.HmacSHA256(
                JSON.stringify(response),
                "partner_central_analytics",
              ).toString(CryptoJS.enc.Hex)) ||
          response instanceof Blob ||
          response.type === "application/zip"
        ) {
          sessionStorage.setItem("isSessionExpired", "0");
          global.isSessionExpired = false;
          global.tokenSamlMismatch = false;
          if (successAction) {
            dispatch({
              type: successAction,
              payload: response,
              data: params,
              params,
              callbackData,
              extraData,
              tab,
            });
          }

          if (callback) {
            callback(response, params);
          }
        } else {
          if (failedAction) {
            // console.log(response);
            if (
              xEncryptedResponse &&
              xEncryptedResponse !==
                CryptoJS.HmacSHA256(
                  JSON.stringify(response),
                  "partner_central_analytics",
                ).toString(CryptoJS.enc.Hex)
            ) {
              logoutUser();
            }
            if (
              response.message === "Session Expired" ||
              response.message === "Token Expired"
            ) {
              global.isSessionExpired = true;
              if (response.message === "Token Expired") {
                global.isTokenExpired = true;
              }
              sessionStorage.setItem("isSessionExpired", "1");
            }
            if (response.message === "Token did not matched the SAML nameID") {
              global.tokenSamlMismatch = true;
            }
            dispatch({
              type: failedAction,
              payload: [],
              data: params,
              error: response,
              extraData,
              tab,
            });
          }
          if (errCallback) {
            errCallback(response, params);
          }
        }
      } catch (e) {
        if (axios.isCancel(e)) {
          console.log("Request canceled:", e.message);
        } else {
          if (failedAction) {
            console.log(e);
            dispatch({
              type: failedAction,
              payload: [],
              data: params,
              error: e,
              tab,
            });
          }
        }
      }
    })
    .catch((e) => {
      if (errCallback) {
        errCallback(e, params);
      }
      if (failedAction) {
        // console.log(e);
        dispatch({
          type: failedAction,
          payload: [],
          data: params,
          error: e,
          tab,
        });
      }
    });
};

export const logoutUser = () => {
  // Create a form element
  const form = document.createElement("form");
  form.method = "POST";
  form.action = window.REACT_APP_LOGOUT_URL;

  // Optionally, add any hidden inputs if needed
  // const hiddenField = document.createElement('input');
  // hiddenField.type = 'hidden';
  // hiddenField.name = 'key';
  // hiddenField.value = 'value';
  // form.appendChild(hiddenField);

  // Append the form to the body and submit it
  document.body.appendChild(form);
  form.submit();
};

export const roundToTwo = (num) => {
  return +(Math.round(+num + "e+2") + "e-2");
};

export const isValid = (value) => {
  if (value !== "" && value !== null && typeof value !== undefined) {
    return true;
  }
  return false;
};

export const storeTokenInCookie = (name, value, options = {}) => {
  // console.log(name);
  options = {
    path: "/",
    // add other defaults here if necessary
    ...options,
  };
  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }
  let updatedCookie = `${name}= ${value}`;
  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }
  document.cookie = updatedCookie;
  //   console.log(updatedCookie);
};
export const provideToken = () => {
  const parsed = queryString.parse(window.location.search);
  return parsed.token;
};
export const storeTokenInSession = () => {
  const parsed = queryString.parse(window.location.search);
  sessionStorage.setItem("pctoken", parsed.token);
  sessionStorage.setItem("sAMAccountName", parsed.userQuery);
};

export const a11yProps = (index) => {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
};
/**
 * Returns additional header text for sales header
 * @param {string} tile - Name of the sales tile
 * @returns {string} - Sales header with additional text
 * @example
 * getSalesHeader("Primary sales")
 */
export const getSalesHeader = (tile) => {
  let obj =
    {
      "Primary sales": "(RR to ZD)",
      "Secondry sales": "(ZD to RDS)",
      "Secondary sales": "(ZD to RDS)",
      "Tertiary sales": "(RDS to Retailer)",
      "Sell out": "(Retailers to Customer)",
      "Secondry sales (MT Chain)": "(ZDMT to Chain)",
      Primary: "(RR to ZD)",
      Secondry: "(ZD to RDS)",
      Secondary: "(ZD to RDS)",
      Tertiary: "(RDS to Retailer)",
    }[tile] || "";
  return obj;
};

export const getPartnerFromToken = (partnerRole) => {
  let obj = {
    NHQ: "NHQ",
    "ZONAL DISTRIBUTOR": "ZD",
    "REGIONAL DISTRIBUTOR": "RDS",
    ARD: "ARD",
    "MICRO ARD": "MARD",
    "ZD MODERN TRADE": "ZDMT",
    "MT INDIRECT CHAIN": "CHAIN",
    "IT ZD": "ITZ",
    "IT RDS": "ITD",
    "MT DIRECT CHAIN": "DT",
    "ENTERPRISE DISTRIBUTOR": "END",
    "ENTERPRISE DISTRIBUTOR LITE": "XG",
    "STATE HEAD": "STATE",
    "REGION HEAD": "REGION",
    JC: "JC",
    "GENERAL RETAILERS": "GENERAL_RETAILERS",
    "RURAL ZDIT": "RZD",
    JPM: "JP",
    "AREA MANAGER": "AREA",
    "JIO BUSINESS ASSOCIATE PARTNER": "JBAP",
    "JIO BUSINESS ASSOCIATE": "JBA",
    "JR. TECHNICIANS TYPE 2": "J4",
    "DIRECT LCO": "DLCO",
    "JIOFIBER JC RETAILER": "EV",
    "FTTX DISTRIBUTOR": "Z8",
    "JIOFIBER JC SALES ENTREPRENR": "ET",
    "HOME SERVICE PARTNER": "HSP",
    "INTEGRATED INDIRECT LCO PARTNER": "DE",
    "INTEGRATED DIRECT LCO PARTNER": "DO",
    "DIRECT LCO PARTNER - SSP": "DQ",
    "INTEGRATED DIST LCO PARTNER": "DX",
    "JC DIGITAL SERVICE CENTRE": "EO",
    "JIOFIBER JP SALES ENTREPRENR": "EU",
    "TECHNICIANS TYPE 1": "J1",
    "JR. TECHNICIANS TYPE 1": "J2",
    "TECHNICIANS TYPE 2": "J3",
    "FIBER DIRECT PARTNER": "JA",
    "FIBER INDIRECT PARTNER": "JB",
    "HSP LITE PARTNER": "J7",
    "HSP LITE1 PARTNER": "JH",
    "JIO ASSOCIATE TRAINEE - HOME": "JK",
    "JIOFIBER SALES PARTNER": "JX",
    "JFH SALES SERVICE PARTNER": "JY",
    "JIOFIBER SERVICE PARTNER": "JZ",
    "JP STORE ASSOCIATE V1": "QD",
    "JP STORE ASSOCIATE V2": "QE",
    "INDIRECT LCO": "Z7",
    "JC FTTX BUSINESS EXECUTIVE METRO": "FTX",
    JA: "JA",
    JB: "JB",
    J7: "J7",
    JX: "JX",
    JY: "JY",
    default: "",
  };
  return obj[partnerRole] || obj["default"];
};

export const getPartnerValue = (role, value) => {
  switch (role) {
    case "REGION":
      return (
        value.region.charAt(0).toUpperCase() +
        value.region.slice(1).toLowerCase()
      );

    case "STATE":
      return (
        value.state.charAt(0).toUpperCase() + value.state.slice(1).toLowerCase()
      );

    case "AREA":
      return (
        value.area.charAt(0).toUpperCase() + value.area.slice(1).toLowerCase()
      );

    default:
      return "";
  }
};

export const mapTokenToRoleId = (partner) => {
  let partner1 = typeof partner !== "undefined" ? partner : "";
  let partner_map = partner1.trim() || partner1;
  let tokenObj = {
    ZD: "754",
    RDS: "755",
    ARD: "752",
    MARD: "782",
    ZDMT: "757",
    CHAIN: "759",
    ITZ: "ITZ",
    ITD: "ITD",
    DT: "756",
    END: "END",
    RZD: "RZD",
    NHQ: "",
    STATE_HEAD: "",
    REGION_HEAD: "",
    JC: "",
    GENERAL_RETAILERS: "",
    JP: "",
    AREA: "",
    JBAP: "142",
    JBA: "JBA",
    J4: "135",
    DLCO: "131",
    EV: "138",
    Z8: "130",
    ET: "136",
    HSP: "HSP",
    DE: "156",
    DO: "164",
    DQ: "166",
    DX: "148",
    EO: "147",
    EU: "137",
    J1: "132",
    J2: "133",
    J3: "134",
    JA: "140",
    JB: "141",
    J7: "180",
    JH: "194",
    JK: "189",
    JX: "172",
    JY: "173",
    JZ: "174",
    QD: "185",
    QE: "183",
    Z7: "109",
    FTX: "FTX",
    XG: "199",
    default: "",
  };
  return tokenObj[partner_map] || tokenObj["default"];
};

export const getPartnerRoleName = (id) => {
  switch (id) {
    case "757":
      return "ZDMT";

    case "754":
      return "ZD";

    case "755":
      return "RDS";

    case "752":
      return "ARD";

    case "782":
      return "MARD";

    case "756":
      return "DT";

    case "759":
      return "CHAIN";

    case "199":
      return "XG";

    case "156":
      return "DE";
    case "164":
      return "DO";
    case "166":
      return "DQ";
    case "148":
      return "DX";
    case "147":
      return "EO";
    case "137":
      return "EU";
    case "132":
      return "J1";
    case "133":
      return "J2";
    case "134":
      return "J3";
    case "140":
      return "JA";
    case "141":
      return "JB";
    case "180":
      return "J7";
    case "194":
      return "JH";
    case "189":
      return "JK";
    case "172":
      return "JX";
    case "173":
      return "JY";
    case "174":
      return "JZ";
    case "185":
      return "QD";
    case "183":
      return "QE";
    case "109":
      return "Z7";

    default:
      return id;
  }
};

export const getPartnerRoleID = (id) => {
  switch (id) {
    case "ZDMT":
      return "757";

    case "ZD":
      return "754";

    case "RDS":
      return "755";

    case "ARD":
      return "752";

    case "MARD":
      return "782";

    case "DT":
      return "756";

    case "CHAIN":
      return "759";

    case "XG":
      return "199";

    case "DE":
      return "156";
    case "DO":
      return "164";
    case "DQ":
      return "166";
    case "DX":
      return "148";
    case "EO":
      return "147";
    case "EU":
      return "137";
    case "J1":
      return "132";
    case "J2":
      return "133";
    case "J3":
      return "134";
    case "JA":
      return "140";
    case "JB":
      return "141";
    case "J7":
      return "180";
    case "JH":
      return "194";
    case "JK":
      return "189";
    case "JX":
      return "172";
    case "JY":
      return "173";
    case "JZ":
      return "174";
    case "QD":
      return "185";
    case "QE":
      return "183";
    case "Z7":
      return "109";
    case "FTX":
      return "FTX";

    default:
      return id;
  }
};

export const deleteNextObjects = (key, obj) => {};

export const filterData = (filterBy, existingArray, filterList, roleType) => {
  const data = filterList?.data;
  if (!filterBy) {
    const regionalData = config.region;
    const out = {
      Region: regionalData,
    };
    // Reseed calls this with no payload; do not drop scheme columns already filled by
    // filterSchemeType / filterSchemeName (avoids skeleton while hierarchy APIs are still pending).
    if (
      existingArray &&
      typeof existingArray === "object" &&
      !Array.isArray(existingArray)
    ) {
      if (Object.prototype.hasOwnProperty.call(existingArray, "Scheme_Type")) {
        out.Scheme_Type = existingArray.Scheme_Type;
      }
      if (Object.prototype.hasOwnProperty.call(existingArray, "Scheme")) {
        out.Scheme = existingArray.Scheme;
      }
    }
    return out;
  } else {
    let keys = Object.keys(existingArray);
    let index = keys.findIndex((x) => x === filterBy.option);

    for (let i = 0; i < keys.length; i++) {
      if (keys[i] !== "Retail Category") {
        if (i > index) {
          // Never cascade-delete scheme columns: Region/State/ZD reseed would remove them whenever
          // Scheme_Type appears before "State" in key order, or after ZD runs. New scheme data
          // overwrites via GET_FILTER_SCHEME_*_SUCCESS; payout changeHandler refetches on real edits.
          if (keys[i] === "Scheme_Type" || keys[i] === "Scheme") {
            continue;
          }
          delete existingArray[keys[i]];
        }
      }
    }
    // let newa = Object.keys(existingArray).splice(index, a.length);
    // let existingArray = deleteNextObjects(filterBy.option, existingArray1)
    const filteredBy = data && data.content;
    let nextItem =
      config.dashboardFilterFormConf[roleType] &&
      config.dashboardFilterFormConf[roleType].findIndex(
        (data) => data.name === filterBy.option,
      );
    let elem =
      config.dashboardFilterFormConf[roleType] &&
      config.dashboardFilterFormConf[roleType][nextItem + 1].name;
    let fData = [];
    let addAllArr = ["ALL"];
    // let category = global.retailCategory;
    if (elem !== "Retail Category") {
      if (elem === "State") {
        fData = config.states[filterBy.data];
      } else if (elem === "ZD/ZDMT/ARD/MARD") {
        let partnerRoleArray = data?.content
          .filter(
            (obj) =>
              obj.partnerRoleType !== "755" &&
              obj.partnerRoleType !== "759" &&
              obj.partnerRoleType !== "ITD" &&
              obj.partnerRoleType !== "RDS",
          )
          .map(
            (obj) =>
              getPartnerRoleName(obj.partnerRoleType) +
              " - " +
              obj.partnerName +
              " - " +
              obj.partnerId,
          );

        const partnerItemOrder = [
          "ZD",
          "ZDMT",
          "ITZ",
          "ARD",
          "MARD",
          "DT",
          "RZD",
          "END",
          "CHAIN",
        ];
        fData = partnerRoleArray
          ?.filter((item, index) => partnerRoleArray.indexOf(item) === index)
          .sort(
            (a, b) =>
              partnerItemOrder.indexOf(a.split(" - ")[0]) -
              partnerItemOrder.indexOf(b.split(" - ")[0]),
          );
      } else if (elem === "RDS/Chain") {
        let rChainList = data?.content
          .filter((obj) => obj.parentId === filterBy.data.split(" - ")[2])
          .map(
            (obj) =>
              getPartnerRoleName(obj.partnerRoleType) +
              " - " +
              obj.partnerName +
              " - " +
              obj.partnerId,
          );
        fData = rChainList
          ?.filter((item, index) => rChainList.indexOf(item) === index)
          .sort();
        fData = addAllArr?.concat(fData);
      } else {
        fData = [
          ...new Set(filteredBy.map((data) => data[elem.toLowerCase()])),
        ];
      }
    }

    let obj = {
      ...existingArray,
    };
    if (elem === "ZD/ZDMT/ARD/MARD" && !filterList?.loading) {
      if (filterList.error === null) {
        if (fData.length === 0) {
          obj = {
            ...existingArray,
            [elem]: fData,
            "RDS/Chain": [],
          };
        } else {
          obj = {
            ...existingArray,
            [elem]: fData,
          };
        }
      } else {
        obj = {
          ...existingArray,
          [elem]: "Error fetching data",
          "RDS/Chain": "Error fetching data",
        };
      }
    } else {
      obj = {
        ...existingArray,
        ...(elem !== "Retail Category" && { [elem]: fData }),
      };
    }
    return obj;
  }
};

export const updatedSchemeFilter = (type, existingObj, newArray) => {
  let obj = existingObj;
  let a = ["ALL"];
  if (newArray && newArray?.content && newArray?.content?.length) {
    let array = newArray.content.map((data, key) => {
      if (
        type === "Retail Category" ||
        type === "Distributors" ||
        type === "Retailers" ||
        type === "JC" ||
        type === "RDS/ARD/MARD" ||
        type === "All/JP"
      ) {
        return data;
      } else if (type === "Scheme") {
        return data.schemeCode;
      } else if (type === "All/JC/JP") {
        return data?.jpId;
      } else {
        return data.schemeType;
      }
    });
    if (
      type === "Scheme" ||
      type === "Retail Category" ||
      type === "All/JC/JP" ||
      type === "All/JP" ||
      type === "Distributors" ||
      type === "Retailers"
    ) {
      array = a.concat(array);
    }
    obj = {
      ...existingObj,
      [type]: array,
    };
    // existingObj[type] : array
  } else {
    if (type === "Scheme_Type") {
      obj = {
        ...existingObj,
        Scheme_Type: [],
        Scheme: [],
      };
    } else if (type === "Scheme") {
      obj = {
        ...existingObj,
        Scheme: [],
      };
    }
  }
  return obj;
};

/**
 * Builds selectedOptionData so each dropdown shows the first list option (e.g. Retail Category → "ALL")
 * after Home/back reset. Skips error placeholders and empty lists.
 */
export const defaultSelectedOptionsFromFilteredArray = (filteredArray) => {
  if (
    !filteredArray ||
    typeof filteredArray !== "object" ||
    Array.isArray(filteredArray)
  ) {
    return {};
  }
  const out = {};
  for (const key of Object.keys(filteredArray)) {
    const val = filteredArray[key];
    if (val === "Error fetching data") {
      continue;
    }
    if (!Array.isArray(val) || val.length === 0) {
      continue;
    }
    const first = val[0];
    if (typeof first === "string" && first === "Error fetching data") {
      continue;
    }
    out[key] = first;
  }
  return out;
};

export const getSalesSockObj = (data) => {
  let obj = {};
  const deviceModule = data.content.filter((mod) => {
    return mod.moduleName === "Device Sales";
  });
  const section =
    deviceModule && deviceModule[0] && deviceModule[0].modSecMasterTxDtos;
  obj.distObj =
    section &&
    section.filter((sec) => {
      return sec.sectionName === "Distribution";
    });
  obj.salesObj =
    section &&
    section.filter((sec) => {
      return sec.sectionName === "Sales";
    });
  obj.stockObj =
    section &&
    section.filter((sec) => {
      return sec.sectionName === "Stock";
    });

  const rechargeModule = data.content.filter((mod) => {
    return mod.moduleName === "Recharge Sales";
  });
  const section2 =
    rechargeModule && rechargeModule[0] && rechargeModule[0].modSecMasterTxDtos;
  obj.rechargeDistObj =
    section2 &&
    section2.filter((sec) => {
      return sec.sectionName === "Distribution";
    });

  const devicePayoutModule = data.content.filter((mod) => {
    return mod.moduleName === "Device Payout";
  });
  const section3 =
    devicePayoutModule &&
    devicePayoutModule[0] &&
    devicePayoutModule[0].modSecMasterTxDtos;
  obj.devicePayoutObj =
    section3 &&
    section3.filter((sec) => {
      return sec.sectionName === "Payout";
    });

  const rechargePayoutModule = data.content.filter((mod) => {
    return mod.moduleName === "Recharge Payout";
  });
  const sectionRP =
    rechargePayoutModule &&
    rechargePayoutModule[0] &&
    rechargePayoutModule[0].modSecMasterTxDtos;
  obj.rechargePayoutObj =
    sectionRP &&
    sectionRP.filter((sec) => {
      return sec.sectionName === "Payout";
    });

  const activationPayoutModule = data.content.filter((mod) => {
    return mod.moduleName === "Activation Payout";
  });
  const sectionAP =
    activationPayoutModule &&
    activationPayoutModule[0] &&
    activationPayoutModule[0].modSecMasterTxDtos;
  obj.activationPayoutObj =
    sectionAP &&
    sectionAP.filter((sec) => {
      return sec.sectionName === "Payout";
    });

  return obj;
};

export const getRDSShort = (data) => {
  let obj =
    {
      "/device-distribution-rds": "rds",
      "/device-distribution-retailer": "ret",
      "/device-distribution-pref-retailer": "pref-ret",
    }[data] || "none";

  return obj;
};

export const getHeaders = (Tab) => {
  switch (Tab) {
    case "JIOPHONE":
      return {
        matModel: "MODEL",
        model: "JIOPHONE",
        salesCsvLineItem: "LYF",
      };
    case "JIOFI":
      return {
        matModel: "MODEL",
        model: "",
        salesCsvLineItem: "JIOFI",
      };
    case "OWN BRAND":
      return {
        matModel: "MODEL",
        model: "",
        salesCsvLineItem: "LYF",
      };
    case "ACCESORIES":
      return {
        matModel: "MODEL",
        model: "",
        salesCsvLineItem: "ACCESORIES",
      };

    case "JIO PHONE VOUCHER":
      return {
        matModel: "MODEL",
        model: "",
        salesCsvLineItem: "JIO PHONE VOUCHER",
      };

    case "JIO PHONE":
      return {
        matModel: "MODEL",
        model: "JIOPHONE",
        salesCsvLineItem: "LYF",
      };

    case "Jio Phone Next":
      return {
        matModel: "MODEL",
        model: "Jio Phone Next",
        salesCsvLineItem: "JIO",
      };

    case "PARTNER BRAND":
      return {
        matModel: "MODEL",
        model: "",
        salesCsvLineItem: "PARTNER BRAND",
      };

    case "Jio Bharat":
      return {
        matModel: "MODEL",
        model: "JIO BHARAT",
        salesCsvLineItem: "JI0",
      };
    default:
      return null;
  }
};

export const calculatePercentage = (data) => {
  let sum = data.reduce(function (a, b) {
    return a + b;
  }, 0);

  let updatedArray = data.map((value) => value / sum);
  return updatedArray;
};

export const getTodaysDate = (current_datetime) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let formatted_date =
    ("0" + current_datetime.getDate()).slice(-2) +
    "-" +
    months[current_datetime.getMonth()] +
    "-" +
    current_datetime.getFullYear();
  return formatted_date;
};

/**
 * Default global header range: up to 6 days ending today, with "from" set to the 1st of the
 * current month when today−6 falls in the previous month (same rule as payout date UX).
 */
export const getDefaultHeaderDateRangeToday = () => {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - 6);
  const firstOfMonth = new Date(end.getFullYear(), end.getMonth(), 1);
  if (start < firstOfMonth) {
    start.setTime(firstOfMonth.getTime());
  }
  return {
    from: getTodaysDate(start),
    to: getTodaysDate(end),
  };
};

export const getRdsFullData = (data, tab) => {
  let rdsData;

  rdsData = data.map((row, index) => {
    const {
      region,
      state,
      zd,
      zdName,
      rds,
      rdsName,
      retailer,
      retailerName,
      jprTypeName,
      partnerRoleType,
    } = row;
    let tabData =
      {
        rds: () => {
          return {
            id: index + 1,
            rds: rds,
            rdsName: rdsName,
            zd: zd,
            zdName: zdName,
            region: region,
            state: state,
          };
        },
        ret: () => {
          return {
            id: index + 1,
            retailer: retailer,
            retailerName: retailerName,
            jprType: jprTypeName,
            role: partnerRoleType,
            zd: zd,
            zdName: zdName,
            region: region,
            state: state,
          };
        },
      }[tab] ||
      (() => {
        return {
          id: index + 1,
          retailer: retailer,
          retailerName: retailerName,
          jprType: jprTypeName,
          role: partnerRoleType,
          zd: zd,
          zdName: zdName,
          region: region,
          state: state,
        };
      });
    return tabData;
  });

  return rdsData;
};

export const validatePartnerRoleType = (roleType) => {
  let validateRT = config.validateRoleTypes[roleType];
  return validateRT;
};

/** Feature 25650900 — roles that may not use scheme ALL on Activation/Recharge Payout (requirement.md §3). */
export const PAYOUT_SCHEME_ALL_RESTRICTED_ROLES = [
  "ZD",
  "RDS",
  "ARD",
  "MARD",
  "RZD",
  "ITZ",
  "ITD",
  "ZDMT",
  "CHAIN",
  "DT",
  "END",
];

/** Exact copy per requirement VAL-02 / ADR-25650900-04 */
export const PAYOUT_ALL_SCHEME_NOT_ALLOWED_MESSAGE =
  "'ALL' Option not allowed for the logged in user role.";

export const isRestrictedPayoutSchemeAllRole = (roleType) => {
  if (roleType == null || typeof roleType !== "string") return false;
  return PAYOUT_SCHEME_ALL_RESTRICTED_ROLES.includes(
    roleType.trim().toUpperCase(),
  );
};

/**
 * Role code for payout scheme ALL restriction (Feature 25650900).
 * Partner login: logged-in channel partner role from filter.
 * Business login (NHQ, REGION, ...): logged-in role only - not the selected row in partner dropdowns.
 */
export const getPayoutSchemeRestrictionPartnerRole = (
  filterValue,
  _selectedOptionData,
  isBusinessType,
  loggedInPartnerRoleType,
) => {
  if (!isBusinessType?.businessType) {
    return (filterValue?.selectedPartnerRoleName || "").trim();
  }
  return (loggedInPartnerRoleType || filterValue?.partnerName || "").trim();
};

export const validateDashboardFilter = (
  roleType,
  component,
  showCategory,
  isChild,
  partnerRT,
  subComponent,
) => {
  let validateDF;
  if (component === "payout") {
    validateDF = config.payoutFilterFormConf[roleType];
    validateDF = validateDF.filter((data, index) => {
      return data.name !== "All/JC/JP";
    });

    if (isChild) {
      validateDF = validateDF.filter((data, index) => {
        return data.name !== "Distributors";
      });
    }

    if (
      subComponent === "activation" ||
      subComponent === "device" ||
      subComponent === "recharge"
    ) {
      validateDF = validateDF.filter((data) => data.name !== "Retailers");
    }

    if (subComponent === "activation") {
      if (partnerRT === "ITZ") {
        validateDF = validateDF.filter((data, i) => {
          return data.name !== "RDS/Chain";
        });
      }
    }
    // else if (subComponent === "device" || subComponent === "recharge") {
    //     if (partnerRT === "ITZ") {
    //         validateDF = validateDF.filter((data, i) => {
    //             return data.name !== "RDS/Chain"
    //         })
    //     }
    // }
  } else if (component === "myEarnings") {
    validateDF = config.dashboardFilterFormConf[roleType];
    validateDF = validateDF.filter((data, index) => {
      return (
        data.name !== "All/JC/JP" &&
        data.name !== "Retail Category" &&
        data.name !== "Scheme_Type" &&
        data.name !== "Scheme"
      );
    });
  } else {
    validateDF = config.dashboardFilterFormConf[roleType];
    if (!showCategory) {
      validateDF = validateDF.filter((data, index) => {
        return data.name !== "Retail Category";
      });
    }
  }
  if (partnerRT === "ARD" || partnerRT === "MARD" || partnerRT === "RZD") {
    validateDF = validateDF.filter((data, index) => {
      return data.name !== "RDS/Chain";
    });
  }
  return validateDF;
};

/**
 * Check if value is an object or not
 * @param {*} value - Value to be tested
 * @returns {boolean} True if value is an object else false
 * @example
 * isEmptyObject({})
 * isEmptyObject({name: 'abc'})
 */
export const isEmptyObject = (value) => {
  return (
    Object.prototype.toString.call(value) === "[object Object]" &&
    JSON.stringify(value) === "{}"
  );
};

export const getActivationSalesObj = (data) => {
  let obj = {};
  const activationModule = data.content.filter((mod) => {
    return mod.moduleName === "Activation";
  });
  const section = activationModule && activationModule[0].modSecMasterTxDtos;
  obj.distObj = section.filter((sec) => {
    return sec.sectionName === "Distribution";
  });
  obj.simBillingObj = section.filter((sec) => {
    return sec.sectionName === "Sim Billing";
  });
  obj.mdnSimConnectivityObj = section.filter((sec) => {
    return sec.sectionName === "MDN Sim Connectivity";
  });

  return obj;
};

export const billedFilter = (data, module) => {
  if (module === "DEVICE" || module === "recharge" || module === "ACTIVATION") {
    data &&
      data.map((obj) => {
        delete obj["jioCenter"];
        delete obj["jcName"];
        delete obj["jprTypeName"];
        delete obj["lmtdUao"];
        delete obj["mtdUao"];
        delete obj["status"];
        return obj;
      });
  }
  return data;
};
export const onBoardedFilter = (data, module) => {
  if (module === "DEVICE" || module === "recharge" || module === "ACTIVATION") {
    data &&
      data.map((obj) => {
        delete obj["rds"];
        delete obj["rdsName"];
        delete obj["partnerRoleType"];

        return obj;
      });
  }
  return data;
};

/**
 * Format tilename to display appropriate tile header
 * @param {string} tileName - Name of tile to format
 * @returns {string}  Returns formatted tile name
 * @example
 * formatTileName("Sim Activation")
 */
export const formatTileName = (tileName) => {
  let formatted =
    {
      "Sim Activation": "Sim Activation",
      DAO: "Daily Activating Outlet",
      TOP5: "Top 5 Retailers",
      BOT5: "Bottom 5 Retailers",
      "Top 5": "Top 5 Retailers",
      "Bot 5": "Bottom 5 Retailers",
      Last7Day: "Last 7 Days",
      "Last 7 days SIM Activation Trend ( Always from current day -7)":
        "Last 7 Days",
      "Last 7 Days Recharge Sales Retailer Count & Transaction Trend":
        "Last 7 Days",
      "Caf Pendency": "Order Input Details",
      zdPayout: "ZD Payout",
      rdsPayout: "RDS Payout",
      retPayout: "Retailer Payout",
      totalPayout: "Total Payout",
    }[tileName] || tileName;
  return formatted;
};

/**
 * @description Function to format table heading
 * @version 0.0.2
 * @param {string} heading - Individual heading to be formatted
 * @returns {string} Formatted table header
 * @example
 * formatHeaderName("lmtdSimAct")
 */
export const formatHeaderName = (heading) => {
  let headerObj = {
    lmtdSimAct: "LMTD Sim Activation",
    mtdSimAct: "MTD Sim Activation",
    retailerName: "Retailer Name",
    lfmSimAct: "LFM Sim Activation",
    mtdJiophoneAct: "MTD Jio Phone Activation",
    ftdOrders: "FTD Orders",
    walletBalance: "Wallet Balance",
    jiophoneStock: "Jio Phone Stock",
    d1SimAct: "D-1 Sim Activation",
    phoneNo: "",
    primaryNo: "",
    partnerName: "Retailer Name",
    ftdMnpOrders: "FTD MNP ORN",
    d1MnpOrders: "D-1 MNP ORN",
    d1MnpActivation: "D-1 MNP Actn.",
    mtdMnpActivations: "MTD MNP Actn.",
    lmtdMnpActivations: "LMTD MNP Actn.",
    lfmMnpActivations: "LFM MNP Actn.",
    default: "",
  };
  return headerObj[heading] || headerObj["default"];
};

export const lmtdCheck = (fromDate, toDate) => {
  const fromMonth = new Date(fromDate);
  const fromDay = fromMonth.getDate();

  const toMonth = new Date(toDate);
  //const toDay=toMonth.getDate();

  const fromMonthCheck = fromMonth.getMonth() + 1;
  const toMonthCHeck = toMonth.getMonth() + 1;

  const fromDateCheck = new Date(
    fromMonth.getFullYear(),
    fromMonth.getMonth(),
    1,
  );
  const fromDayCheck = fromDateCheck.getDate();

  //    const toDateCheck= new Date(fromMonth.getFullYear(),fromMonth.getMonth()+1,0)
  //    const toDayCheck=toDateCheck.getDate();

  if (fromMonthCheck === toMonthCHeck) {
    if (fromDay === fromDayCheck) {
      return true;
    } else return false;
  } else return false;
};

export const payoutMapping = (data) => {
  let mapped = [];
  if (data && data.content) {
    let keys = Object.keys(data.content);
    let values = Object.values(data.content);
    mapped = keys.map((value, i) => {
      return { tileName: value, tileValue: values[i] };
    });
  }

  // let obj = {};

  // if (data && data.content) {
  //     obj.qty = data.qty;
  //     obj.data = Object.keys(data.content).map(i => data.content[i]);
  // }
  return mapped;
};

export const earningsMapping = (data) => {
  return data;
};

export const payoutHeader = (role, data) => {
  if (role === "ZD") {
    return [
      {
        tileName: "ZD Payout",
        tileValue: data?.zdPayout,
      },
      {
        tileName: "RDS Payout",
        tileValue: data?.rdsPayout,
      },
      {
        tileName: "Retailer Payout",
        tileValue: data?.retPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
      },
    ];
  } else if (role === "RDS") {
    return [
      {
        tileName: "RDS Payout",
        tileValue: data?.rdsPayout,
      },
      {
        tileName: "Retailer Payout",
        tileValue: data?.retPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
      },
    ];
  } else if (role === "ZDMT") {
    return [
      {
        tileName: "ZDMT Payout",
        tileValue: data?.zdPayout,
      },
      {
        tileName: "Chain Payout",
        tileValue: data?.rdsPayout,
      },
      {
        tileName: "Store Payout",
        tileValue: data?.retPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
      },
    ];
  } else if (role === "ITZ") {
    return [
      {
        tileName: "ITZ Payout",
        tileValue: data?.zdPayout,
      },
      {
        tileName: "ITD Payout",
        tileValue: data?.rdsPayout,
      },
      {
        tileName: "Retailer Payout",
        tileValue: data?.retPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
      },
    ];
  } else if (role === "ITD") {
    return [
      {
        tileName: "ITD Payout",
        tileValue: data?.rdsPayout,
      },
      {
        tileName: "Retailer Payout",
        tileValue: data?.retPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
      },
    ];
  } else if (role === "ARD") {
    return [
      {
        tileName: "ARD Payout",
        tileValue: data?.rdsPayout,
        // tileValue: schemeType === "RDS" ? 0 : data?.zdPayout,
      },
      {
        tileName: "UAO/URO Payout",
        tileValue: data?.retPayout,
        // tileValue: schemeType === "RDS" ? 0 : data?.retPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
        // tileValue: schemeType === "RDS" ? 0 : data?.totalPayout,
      },
    ];
  } else if (role === "MARD") {
    return [
      {
        tileName: "MARD Payout",
        tileValue: data?.rdsPayout,
        // tileValue: schemeType === "RDS" ? 0 : data?.zdPayout,
      },
      {
        tileName: "UAO/URO Payout",
        tileValue: data?.retPayout,
        // tileValue: schemeType === "RDS" ? 0 : data?.retPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
        // tileValue: schemeType === "RDS" ? 0 : data?.totalPayout,
      },
    ];
  } else if (role === " DT") {
    return [
      {
        tileName: "DT Payout",
        tileValue: data?.zdPayout,
      },
      {
        tileName: "Retailer Payout",
        tileValue: data?.retPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
      },
    ];
  } else if (role === "RZD") {
    return [
      {
        tileName: "RZD Payout",
        tileValue: data?.zdPayout,
      },
      {
        tileName: "Retailer Payout",
        tileValue: data?.retPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
      },
    ];
  } else if (role === "CHAIN") {
    return [
      {
        tileName: "Chain Payout",
        tileValue: data?.rdsPayout,
      },
      {
        tileName: "Store Payout",
        tileValue: data?.retPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
      },
    ];
  } else if (role === "END") {
    return [
      {
        tileName: "ED Payout",
        tileValue: data?.zdPayout,
      },
      {
        tileName: "Total Payout",
        tileValue: data?.totalPayout,
      },
    ];
  }
};
export const checkPayoutCsv = (startDate, endDate) => {
  const selectedFrom = +startDate.split("-")[0]; //new Date(startDate).getDate();
  const selectedTo = +endDate.split("-")[0]; //new Date(endDate).getDate();
  const difference = selectedTo - selectedFrom;
  if (difference <= 7) {
    return true;
  } else return false;
};

/**
 * Format header fields of estel ledger module
 * @param {string} field - Individual header field
 * @returns {string} Formatted header field
 * @example
 * formatEstelHeaderNames("distributorId")
 */
export const formatEstelHeaderNames = (field) => {
  let obj = {
    transactionDate: "Transaction Date",
    transactionId: "Transaction ID",
    retailerCode: "Retailer Code",
    transactionType: "Transaction",
    resultCode: "Result Code",
    transactionDesc: "Transaction Type",
    distributorId: "Distributor Id",
    parentRoleName: "Parent Role Name",
    openingBalance: "Opening Balance",
    credit: "Credit",
    debit: "Debit",
    closingBalance: "Closing Balance",
    ornNumber: "ORN Number",
    fosId: "FOS ID",
    default: "",
  };
  return obj[field] || obj["default"];
};

export const partnerIdentityForPayouts = (role) => {
  let formatted =
    {
      ZD: "1",
      RDS: "2",
      ARD: "1",
      MARD: "1",
      ZDMT: "1",
      CHAIN: "2",
      ITZ: "1",
      ITD: "2",
      DT: "1",
      END: "1",
      RZD: "1",
    }[role] || role;
  return formatted;
};
export const getNavigationLinks = (partnerRoleName, content = []) => {
  let activeModules = content;
  // let businessLinks = {
  //   "/deviceSales/": "Device Sales",
  //   "/activationSales/": "Activation Sales",
  //   "/rechargeSales/": "Recharge Sales ",
  //   "/devicePayout/": "Device Payout",
  //   "/activationPayout/": "Activation Payout",
  //   "/rechargePayout/": "Recharge Payout",
  //   "/myEarnings/": "My Earnings",
  // };
  // let areaLinks = {
  //   "/devicePayout/": "Device Payout",
  //   "/activationPayout/": "Activation Payout",
  //   "/rechargePayout/": "Recharge Payout",
  //   "/myEarnings/": "My Earnings",
  // };
  // let jPLinks = {
  //   "/deviceSales/": "Device Sales",
  //   "/activationSales/": "Activation Sales",
  //   "/rechargeSales/": "Recharge Sales ",
  // };
  let formatted = {
    // NHQ: businessLinks,
    // STATE: businessLinks,
    // REGION: businessLinks,
    // JC: businessLinks,
    // AREA: areaLinks,
    // JP: jPLinks,
    default: (() => {
      if (activeModules && activeModules.length) {
        let partnerLinks;
        const drawerLinkKey = (s) => {
          return (
            "/" +
            s.split(" ").join("").charAt(0).toLowerCase() +
            s.split(" ").join("").slice(1)
          );
        };

        partnerLinks = activeModules.map((mod) => ({
          route: drawerLinkKey(mod.moduleName),
          name: mod.moduleName,
          icon: mod.icon,
        }));
        return partnerLinks;
      }
    })(),
  };
  return formatted[partnerRoleName] || formatted["default"];
};

export const earningsDispValue = (rowName) => {
  let dispValue =
    {
      CUT_N_PAY: "cutnpay",
      "Recharge Incentive": "rechargeincentive",
      "SCHEME PAYOUT": "schemepayout",
      Margin: "margin",
      "Sim Activation Payout": "schemepayout",
    }[rowName] || "";
  return dispValue;
};

// export const mapChainToOriginal = id => {
//     let formatted = (({
//         "CHAIN": "ZDMTC"
//     })[id] || (id)
//     );
//     return formatted;
// }

export const getJCJPIDs = (filterValue) => {
  let level = "";
  let jioPointId = "";
  let partnerRT = filterValue.selectedPartnerRoleName;
  let partnerType = "";
  let retailerId = "";
  let id = filterValue.orgId
    ? filterValue.orgId
    : filterValue.selectedRole.split(" - ")[2];
  if (filterValue.selectedJC && filterValue.selectedJC !== "ALL") {
    partnerRT = "JC";
    partnerType = "1"; //activation only
    if (
      filterValue.selectedPartnerRoleName === "ARD" ||
      filterValue.selectedPartnerRoleName === "MARD"
    ) {
      partnerType = "2";
    }
    if (filterValue.selectedJC.split("-")[1]) {
      id = "";
      level = filterValue.selectedJC.split("-")[0].trim();
      let arr = filterValue.selectedJC.split("-");
      let l = filterValue.selectedJC.split("-").length;
      jioPointId = arr[l - 1].trim();
    } else {
      level = filterValue.selectedJC;
    }
  }
  if (filterValue.partnerName === "JPM") {
    id = "";
    retailerId = "ALL";
    partnerRT = "JP";
    level = "JP";
    jioPointId = filterValue.selectedArea;
    partnerType = null;

    if (filterValue.selectedJP && filterValue.selectedJP !== "ALL") {
      level = "RETAILER";
      retailerId = filterValue.selectedJP.split("-")[1].trim();
      jioPointId = "";
    }
  }

  return {
    level,
    jioPointId,
    partnerRT,
    partnerType,
    retailerId,
    id,
  };
};

export const rechargeWalletMapping = (data, filterValue) => {
  let arr;
  ({
    ZD: () => {
      arr = [
        {
          tileName: "ZD",
          tileValue: data.zd,
          partnerType: "zd",
          gradient: 3,
        },
        {
          tileName: "RDS",
          tileValue: data.rds,
          partnerType: "rds",
          gradient: 4,
        },
        {
          tileName: "RETAILER",
          tileValue: data.retailer,
          partnerType: "retailer",
          gradient: 5,
        },
      ];
    },
    RDS: () => {
      arr = [
        {
          tileName: "RDS",
          tileValue: data.rds,
          partnerType: "rds",
          gradient: 3,
        },
        {
          tileName: "RETAILER",
          tileValue: data.retailer,
          partnerType: "retailer",
          gradient: 4,
        },
      ];
    },
    ZDMT: () => {
      arr = [
        {
          tileName: "ZDMT",
          tileValue: data.zd,
          partnerType: "zd",
          gradient: 3,
        },
        {
          tileName: "CHAIN",
          tileValue: data.rds,
          partnerType: "rds",
          gradient: 4,
        },
        {
          tileName: "STORE",
          tileValue: data.retailer,
          partnerType: "retailer",
          gradient: 5,
        },
      ];
    },
    ITZ: () => {
      arr = [
        {
          tileName: "ITZ",
          tileValue: data.zd,
          partnerType: "zd",
          gradient: 3,
        },
        {
          tileName: "ITD",
          tileValue: data.rds,
          partnerType: "rds",
          gradient: 4,
        },
        {
          tileName: "RETAILER",
          tileValue: data.retailer,
          partnerType: "retailer",
          gradient: 5,
        },
      ];
    },
    ITD: () => {
      arr = [
        {
          tileName: "ITD",
          tileValue: data.rds,
          partnerType: "rds",
          gradient: 3,
        },
        {
          tileName: "RETAILER",
          tileValue: data.retailer,
          partnerType: "retailer",
          gradient: 4,
        },
      ];
    },
    ARD: () => {
      arr = [
        {
          tileName: "ARD",
          tileValue: data.zd,
          partnerType: "zd",
          gradient: 3,
        },
        {
          tileName: "UAO/URO",
          tileValue: data.retailer,
          partnerType: "retailer",
          gradient: 4,
        },
      ];
    },
    MARD: () => {
      arr = [
        {
          tileName: "MARD",
          tileValue: data.zd,
          partnerType: "zd",
          gradient: 3,
        },
        {
          tileName: "UAO/URO",
          tileValue: data.retailer,
          partnerType: "retailer",
          gradient: 4,
        },
      ];
    },
    DT: () => {
      arr = [
        {
          tileName: "DT",
          tileValue: data.zd,
          partnerType: "zd",
          gradient: 3,
        },
      ];
    },
    RZD: () => {
      arr = [
        {
          tileName: "RZD",
          tileValue: data.zd,
          partnerType: "zd",
          gradient: 3,
        },
        {
          tileName: "RDS",
          tileValue: data.rds,
          partnerType: "retailer",
          gradient: 4,
        },
      ];
    },
    CHAIN: () => {
      arr = [
        {
          tileName: "CHAIN",
          tileValue: data.rds,
          partnerType: "rds",
          gradient: 3,
        },
        {
          tileName: "STORE",
          tileValue: data.retailer,
          partnerType: "retailer",
          gradient: 4,
        },
      ];
    },
    END: () => {
      arr = [
        {
          tileName: "ED",
          tileValue: data.zd,
          partnerType: "zd",
          gradient: 3,
        },
      ];
    },
    JP: () => {
      arr = [
        {
          tileName: "Retailers Wallet Balance",
          tileValue: data.retailer,
          partnerType: "retailer",
          gradient: 3,
        },
      ];
    },
  })[filterValue.selectedPartnerRoleName]();
  return arr;
};

export const getChildForDistributor = (partner) => {
  let childForDistributor =
    {
      ZD: "RDS",
      ITZ: "ITD",
      ZDMT: "CHAIN",
    }[partner] || "";
  return childForDistributor;
};

export const sidebarMapping = (data) => {
  let mapped = [];
  if (data) {
    // console.log("keys", keys);
    // console.log("values", values);
    mapped = data.map((value, i) => {
      return { route: value.route, icon: value.icon, name: value.name };
    });
  }

  let existingArray = [{ route: "/", name: "Home" }];

  return existingArray.concat(mapped);
};

export const timeStampFormat = (ts) => {
  if (!ts) {
    return "";
  }

  var today = new Date(ts);
  var day = today.getDate() + "";
  var month = today.getMonth() + 1 + "";
  var year = today.getFullYear() + "";
  var hour = today.getHours() + "";
  var minutes = today.getMinutes() + "";
  var seconds = today.getSeconds() + "";

  day = checkZero(day);
  month = checkZero(month);
  year = checkZero(year);
  hour = checkZero(hour);
  minutes = checkZero(minutes);
  seconds = checkZero(seconds);

  return (
    day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds
  );

  function checkZero(data) {
    if (data.length == 1) {
      data = "0" + data;
    }
    return data;
  }
};

export const capitalize = (str, lower = true) =>
  (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) =>
    match.toUpperCase(),
  );

export const camelize = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toUpperCase() : match.toLowerCase();
  });
};

export const rupeeFormatNumber = (str) => {
  const result = parseInt(str).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    // style: 'currency',
    // currency: 'INR'
  });
  return result;
};

export const getLastSixMonths = () => {
  const currentDate = new Date();
  const newMonths = [];

  for (let i = 0; i < 6; i++) {
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1,
    );
    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i + 1,
      0,
    );
    const monthName = firstDayOfMonth.toLocaleString("default", {
      month: "short",
    });
    const year = String(firstDayOfMonth.getFullYear()).slice(-2);

    const formattedStartDate = `${("0" + firstDayOfMonth.getDate()).slice(
      -2,
    )}-${monthName}-${year}`;
    const formattedEndDate = `${("0" + lastDayOfMonth.getDate()).slice(
      -2,
    )}-${monthName}-${year}`;

    newMonths.push({
      name: `${firstDayOfMonth.toLocaleString("default", {
        month: "long",
      })} ${year}`,
      value: JSON.stringify({
        start: formattedStartDate,
        end: formattedEndDate,
      }),
    });
  }

  return newMonths; // Reverse to show the most recent month first
};

export const downloadByteArrayAsBlob = (response, filename) => {
  // Read the response as a byte array
  // const blob = await response.blob();

  // Create a URL for the blob
  const url = window.URL.createObjectURL(response);

  // Create a link element
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.csv`;

  // Append the link to the body
  document.body.appendChild(a);

  // Programmatically click the link to trigger the download
  a.click();

  // Clean up
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const downloadArrayAsCSV = (data, filename) => {
  if (!data || !data.length) {
    const csvContent = "No data available";
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    return;
  }

  const headers = Object.keys(data[0]);

  const csvRows = [];

  csvRows.push(headers.join(","));
  for (const row of data) {
    const values = headers.map((header) => {
      const value = row[header] ?? "";
      const escaped = String(value).replace(/"/g, '""');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(","));
  }
  const csvContent = csvRows.join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

/**
 * Feature 25650901: build CSV from API {@code csvHeading} + {@code csvData} (sync payout downloads).
 * @param {{ csvHeading?: string[], csvData?: string[][] }} content
 * @param {string} filenameBase filename without extension
 * @returns {boolean} true if download started
 */
export const downloadPayoutCsvExportContent = (content, filenameBase) => {
  const headings = content?.csvHeading;
  const rows = content?.csvData;
  if (!headings?.length || !rows?.length) {
    return false;
  }
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = [headings.map(esc).join(",")];
  for (const cells of rows || []) {
    lines.push(headings.map((_, i) => esc(cells[i])).join(","));
  }
  const csvContent = "\uFEFF" + lines.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filenameBase || "export"}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
  return true;
};
